var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeCb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7776 0L2.34766 3.43062V7.56938L5.7776 11H6.47266V0.00138474H5.7776V0ZM7.75555 0.369179L7.58712 1.0409C8.47609 1.39971 9.23761 2.01583 9.77412 2.8103C10.3106 3.60477 10.5977 4.54135 10.5984 5.5C10.5966 6.45791 10.3091 7.39353 9.77252 8.18706C9.23595 8.98059 8.47474 9.59592 7.5864 9.95432L7.75417 10.6239C8.79129 10.2263 9.68372 9.52396 10.314 8.60936C10.9443 7.69475 11.2828 6.61074 11.2852 5.5C11.2843 4.38825 10.9466 3.30285 10.3165 2.38691C9.68641 1.47096 8.79351 0.767463 7.75555 0.369179ZM8.0711 2.94319L7.69987 3.53582C7.96298 3.79102 8.17242 4.09627 8.31586 4.43359C8.45931 4.7709 8.53385 5.13346 8.53516 5.5C8.53467 5.86676 8.46083 6.22975 8.31796 6.56755C8.1751 6.90534 7.96613 7.21114 7.70331 7.46695L8.07387 8.06096C8.43475 7.73894 8.72358 7.34437 8.92154 6.90307C9.1195 6.46178 9.22211 5.98366 9.22266 5.5C9.22118 5.01682 9.11786 4.53941 8.91944 4.09886C8.72102 3.6583 8.43196 3.2645 8.0711 2.94319ZM0.285156 3.43821V7.56321H1.66016V3.43821H0.285156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeCb);
export default __webpack_public_path__ + "static/media/volume-cb.8b848844b81d067e3a82285cecdfa7e4.svg";
export { ForwardRef as ReactComponent };